import { Box } from "@mui/material";
import {
  WfIconWorkoutTypesRunningRunning,
  WfIconWorkoutTypesBikingRoad,
} from "@WahooFitness/redesignr";
import RunningProfileLogoSVG from "@/assets/RunningProfileLogo.svg";
import CyclingProfileLogoSVG from "@/assets/CyclingProfileLogo.svg";
import { WahooWorkoutTypeFamily } from "@WahooFitness/cloud-client-types";

const iconMapping: Record<
  WahooWorkoutTypeFamily.Cycling | WahooWorkoutTypeFamily.Running,
  React.ReactNode
> = {
  [WahooWorkoutTypeFamily.Running]: <WfIconWorkoutTypesRunningRunning fontSize="large" />,
  [WahooWorkoutTypeFamily.Cycling]: <WfIconWorkoutTypesBikingRoad fontSize="large" />,
};

const logoMapping: Record<WahooWorkoutTypeFamily.Cycling | WahooWorkoutTypeFamily.Running, string> =
  {
    [WahooWorkoutTypeFamily.Running]: RunningProfileLogoSVG,
    [WahooWorkoutTypeFamily.Cycling]: CyclingProfileLogoSVG,
  };

const AthleteProfileLogo = ({
  profileType,
}: {
  profileType: WahooWorkoutTypeFamily.Cycling | WahooWorkoutTypeFamily.Running;
}) => {
  const icon = iconMapping[profileType];
  const logo = logoMapping[profileType];
  return (
    <Box position="relative" height={72} width={72}>
      <img src={logo} alt={`${WahooWorkoutTypeFamily[profileType]} Profile Logo`} />
      <Box position="absolute" top={20} left={20}>
        {icon}
      </Box>
    </Box>
  );
};

export default AthleteProfileLogo;
